import { ref } from "vue";
import { defineStore } from "pinia";
import { useHttpStore } from "@/stores/http";

export const useGoogleAnalyticsStore = defineStore("google-analytics", () => {
  const httpStore = useHttpStore();

  const getActiveUsersPerDayData = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "googleAnalytics/GetActiveUsersPerDayData", params, { showLoading: true })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getSessionsPerDayData = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "googleAnalytics/GetSessionsPerDayData", params, { showLoading: true })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getEventCountPerDayData = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "googleAnalytics/GetEventCountPerDayData", params, { showLoading: true })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getViewsPerDayData = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "googleAnalytics/GetViewsPerDayData", params, { showLoading: true })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getAnalyticsData = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "googleAnalytics/GetAnalyticsData", params, { showLoading: true })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getRTAnalyticsData = () => {
    var params = {};
    return new Promise((resolve, reject) => {
      httpStore
        .api("get", "googleAnalytics/GetRTAnalyticsData", params, { showLoading: false })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  return {
    getAnalyticsData,
    getRTAnalyticsData,
    getActiveUsersPerDayData,
    getSessionsPerDayData,
    getViewsPerDayData,
    getEventCountPerDayData
  };
});
